import { useEffect } from 'react'
import { useAppDispatch } from 'hooks'
import { fetchDispatchHelpAccess } from '../services/dispatchHelpApi'
import { setIsOperator } from '../store/dispatchHelpSlice'

/**
 * Resolves whether the logged-in admin may operate Dispatch Help (the Gluon-managed allowlist) and
 * stores `isOperator` so the sidebar can hide the surface for non-operators. The access check also
 * registers the admin as a cross-tenant fan-out target server-side — NO heartbeat: delivery is gated
 * on the admin's live WebSocket presence, so closing the tab (socket disconnect) stops fan-out on its
 * own. On an access-check error we treat the admin as NOT an operator (hide rather than expose the
 * cross-tenant surface); the allowlist denies by default server-side when it's empty.
 */
export function useDispatchHelpOperator(enabled: boolean): void {
    const dispatch = useAppDispatch()
    useEffect(() => {
        if (!enabled) return
        let cancelled = false
        void fetchDispatchHelpAccess()
            .then((allowed) => {
                if (!cancelled) dispatch(setIsOperator(allowed))
            })
            .catch(() => {
                if (!cancelled) dispatch(setIsOperator(false))
            })
        return () => {
            cancelled = true
        }
    }, [enabled, dispatch])
}
